import PropTypes from "prop-types";
import { useRef, useState } from "react";
import "../../design-system.css";
import "./NativeSelect.css";
import { ArrowIcon } from "../../assets/assets";

function NativeSelect(props) {
  const [tempSelectionIndex, setTempSelectionIndex] = useState(0);
  const label = useRef(null);
  const multiSelectDropdownRef = useRef(null);
  const [showOptions, setShowOptions] = useState(false);
  const selectElementRef = useRef(null);
  const isSelectElementFocusedRef = useRef(false);

  return (
    <div
      ref={selectElementRef}
      className={`position-relative inherit-parent-width font-size-default 
					${
            props.disabled === true || props.loading === true
              ? " background-color-grey "
              : ""
          }
						${
              props.size === "half"
                ? "min-width-138px"
                : props.size === "small"
                ? "max-width-100px"
                : "min-width-250px"
            }
						${props.className || ""}
					`}
      onClick={() => (isSelectElementFocusedRef.current = true)}
    >
      <div className="height-48px inherit-parent-width flex-align-items-end">
        <div className="flex-center-children-horizontally font-family-gilroy-medium inherit-parent-width">
          <div
            className="inherit-parent-width"
            style={{ position: "relative" }}
          >
            <select
              required={props.required}
              ref={multiSelectDropdownRef}
              className={`native-select text-capitalize padding-left-small padding-right-larger font-color-secondary inherit-parent-width font-family-gilroy-medium font-size-medium padding-top-large padding-bottom-default max-width-100-percentage display-block text-overflow-ellipsis native-select-border-bottom-default ${
                props.disabled
                  ? "font-color-secondary"
                  : props.selectClassName || ""
              } ${
                props.disabled === true || props.loading === true
                  ? " background-color-grey "
                  : ""
              }`}
              value={props.value || ""}
              name={props.name}
              id={props.name}
              disabled={props.disabled || props.loading}
              data-cy={props["data-cy"] || `${props.name}-select-element`}
              onFocus={(event) => {
                if (props.disabled || props.loading) return;
                label.current.classList.add("active");
                setShowOptions(true);
                setTempSelectionIndex(event.target.selectedIndex);
                event.target.selectedIndex = -1;
              }}
              onBlur={(event) => {
                if (!event.target.value) {
                  label.current.classList.remove("active");
                }
                props.onOutOfFocus?.(event);
                if (event.target.selectedIndex === -1) {
                  event.target.selectedIndex = tempSelectionIndex;
                }
              }}
              onChange={(event) => {
                props.onChange?.(event);
              }}
            >
              {Array.isArray(props.options) &&
                props.options.map((data, index) => (
                  <option
                    value={data?.value ?? data}
                    key={index}
                    hidden={data === ""}
                  >
                    {data?.option ?? data}
                  </option>
                ))}
            </select>

            {/* Right-side icon (NO CSS) */}
            <div
              style={{
                position: "absolute",
                right: "12px",
                top: "50%",
                transform: "translateY(-50%)",
                pointerEvents: "none"
              }}
            >
              {props.loading ? (
                <div className="loading-spinner" data-cy="LOADING-SPINNER" />
              ) : (
                <div
                  style={{
                    transform: "rotate(90deg)"
                  }}
                >
                  <ArrowIcon />
                </div>
              )}
            </div>

            {showOptions !== true && (
              <span className="native-select-border-bottom" />
            )}

            <label
              htmlFor={props.name}
              ref={label}
              className={`${
                props.removeResponsive
                  ? "native-select-label"
                  : "adaptive-native-select-label"
              } ${
                props.size === "half"
                  ? "top-45-percentage"
                  : "top-55-percentage"
              } font-color-secondary position-absolute font-family-gilroy-medium font-size-medium
        ${props.labelClassName || ""}
        ${
          (props.value && props.value.length !== 0) || props.alwaysActive
            ? "active"
            : ""
        }`}
            >
              {props.label}
            </label>
          </div>
        </div>
      </div>
      <p
        style={{
          backgroundColor: "white"
        }}
        className="font-size-smaller"
      >
        &nbsp;
      </p>
    </div>
  );
}

NativeSelect.propTypes = {
  /**
   * which is used to disable the input element
   */
  disabled: PropTypes.bool,
  /**
   * to control the min-width of the component
   */
  size: PropTypes.oneOf(["half", "default", "small"]),
  /**
   * class name for parent element of the input component
   */
  className: PropTypes.string,
  /**
   * selected option class name
   */
  selectClassName: PropTypes.string,
  /**
   * name attribute of select input element, and use name attribute for id attribute
   */
  name: PropTypes.string,
  /**
   * prop which return input onChange event as callback
   */
  onChange: PropTypes.func,
  /**
   * sets default value for select input element
   */
  value: PropTypes.string,
  /**
   * which return onBlur event
   */
  onOutOfFocus: PropTypes.func,
  /**
   * array of options taken as input select input element
   */
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        option: PropTypes.string,
        value: PropTypes.string
      })
    ])
  ),
  /**
   * which used to style the label
   */
  labelClassName: PropTypes.string,
  /**
   * which sets the label to active state
   */
  alwaysActive: PropTypes.bool,
  /**
   * which used to set the label for the select input element
   */
  label: PropTypes.string,
  /**
   * required `true` or `false`
   */
  required: PropTypes.bool
};

NativeSelect.defaultProps = {
  size: "default",
  disabled: false,
  className: "",
  selectClassName: null,
  name: undefined,
  onChange: undefined,
  value: null,
  required: false,
  onOutOfFocus: undefined,
  options: [""],
  labelClassName: "",
  label: null
};

export default NativeSelect;
